import type { Location } from 'react-router-dom';

export type ReceptionWorkflowGroup = 'requests' | 'consultations' | 'waiting';

export const receptionWorkflowGroups = {
  requests: {
    title: 'Requests & Interests',
    tabs: [
      { label: 'Requests', to: '/reception/requests' },
      { label: 'Interests', to: '/reception/course-interests' },
    ],
  },
  consultations: {
    title: 'Consultations',
    tabs: [
      { label: 'Slots', to: '/reception/sales-consult-slots' },
      { label: 'Queue', to: '/reception/sales-consult-queue' },
    ],
  },
  waiting: {
    title: 'Waiting Students',
    tabs: [
      { label: 'Students', to: '/reception/students?category=waiting' },
      { label: 'Insights', to: '/reception/waiting-insights' },
    ],
  },
} as const;

export function getReceptionWorkflowGroup(location: Pick<Location, 'pathname' | 'search'>): ReceptionWorkflowGroup | null {
  switch (location.pathname) {
    case '/reception/requests':
    case '/reception/course-interests':
      return 'requests';
    case '/reception/sales-consult-slots':
    case '/reception/sales-consult-queue':
      return 'consultations';
    case '/reception/waiting':
    case '/reception/waiting-insights':
      return 'waiting';
    case '/reception/students':
      return new URLSearchParams(location.search).get('category') === 'waiting' ? 'waiting' : null;
    default:
      return null;
  }
}
